import { render, staticRenderFns } from "./legal-document-diff.vue?vue&type=template&id=5a994bce&scoped=true"
import script from "./legal-document-diff.vue?vue&type=script&lang=js"
export * from "./legal-document-diff.vue?vue&type=script&lang=js"
import style0 from "./legal-document-diff.vue?vue&type=style&index=0&id=5a994bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a994bce",
  null
  
)

export default component.exports